import axiosInstance from '../../../config/axiosInstance';
const SupplierDocumentService = {
    async GetAllStockDiscounts(redirectCallback, StockID) {
        try {
            const response = await axiosInstance.get(`/Part/GetAllStockDiscounts?StockID=${StockID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteStockDiscount(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/DeleteStockDiscount?ID=${ID}`);
            return response.data;
        } catch (error) {
            
            console.error('Error fetching data:', error);
            throw error;
        }
    }
};

export default SupplierDocumentService;